export const createFlightsSummaryActions = Odigeo => {
  const onContinueWithFlight = () => Odigeo.trigger('frontend-shell:onContinueWithFlight');
  return {
    onContinueWithFlight
  };
};